import { render } from "./member-table.vue?vue&type=template&id=1619260a&scoped=true&ts=true"
import script from "./member-table.vue?vue&type=script&lang=ts"
export * from "./member-table.vue?vue&type=script&lang=ts"

import "./member-table.vue?vue&type=style&index=0&id=1619260a&lang=less&scoped=true"

import exportComponent from "/builds/workshop/teambition-frontend/node_modules/.pnpm/vue-loader@16.8.3_6zog4g7lmcedlfqueoidvwcx7q/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1619260a"]])

export default __exports__